import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3541f522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redraw-div" }
const _hoisted_2 = { class: "redraw-title" }
const _hoisted_3 = { class: "redraw-text-list" }
const _hoisted_4 = { class: "list-item" }
const _hoisted_5 = { class: "redraw-input" }

import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { Button, Input, Modal, Tooltip, List, message } from 'ant-design-vue'
import { useSlidesStore,useMainStore } from '@/store'
import { sendClickData } from "@/utils/common";


import { getUserCanChatAndDownLoad } from '@/api/combo'
import { event } from 'vue-gtag'
import Cookies from 'js-cookie'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['click'],
  setup(__props, { emit }) {

const { t, locale } = useI18n()
const slidesStore = useSlidesStore()
const mainStore = useMainStore()

const { redrawData } = storeToRefs(slidesStore)
const { pptId } = storeToRefs(mainStore)



const msg = ref<string>('')
const id = ref<string>('')
const data = ref<any>([])
const confirmContinue = ref(false)
const reDrawNoPricing = ref(false)
onMounted(() => {
  id.value = redrawData.value.id
  // console.log('slide-id', id.value, 'redrawData.value', redrawData.value)
  const list = sessionStorage.getItem(id.value)
  if (list) {
    data.value = JSON.parse(list)
  }

  if (redrawData.value.title) {
    msg.value = redrawData.value.title
    if (data.value.length === 0) {
      data.value.push(msg.value)
      sessionStorage.setItem(id.value, JSON.stringify(data.value))
    }
  }
})

const addList = () => {
  confirmContinue.value = false
  if (msg.value.trim()) {
    data.value.push(msg.value.trim())
    emit('click', msg.value.trim(), id.value)
    msg.value = ''
    sessionStorage.setItem(id.value, JSON.stringify(data.value))
  }
  else {
    message.warning(t(`editor.redraw.msgTips`))
  }
}

const handleRedrawInput = () => {
  getUserCanChatAndDownLoad(pptId.value).then((res: any) => {
    if(res.data == true) {
      confirmContinue.value = true
    } else {
      reDrawNoPricing.value = true
    }
  }).catch ((err: any) => {
  })
}

const handleGetTokens = async() => {
  let userList = Cookies.get('e_a_u')
  let uid = Cookies.get('uid')
  if(userList != undefined) {
    if(uid && userList.split(',').indexOf(uid) == -1){
      // event('14');
    }
  } else {
    // event('14');
  }
  reDrawNoPricing.value = false
  let currentUrl = window.location.href||''
  // ppt Upgrade to Pro=24
  await sendClickData(24,currentUrl,'','redraw')
  window.parent.location.href="/pricing?d=4"
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.redraw.topLabel`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(List), {
        size: "small",
        "data-source": data.value
      }, {
        renderItem: _withCtx(({ item }) => [
          _createVNode(_unref(Tooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Input).TextArea, {
        value: msg.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((msg).value = $event)),
        disabled: !_unref(redrawData).title,
        placeholder: _ctx.$t(`editor.redraw.msgTips`),
        "auto-size": { maxRows: 3 },
        maxlength: 200,
        onPressEnter: addList
      }, null, 8, ["value", "disabled", "placeholder"]),
      _createVNode(_unref(Button), {
        type: "primary",
        style: {"float":"right","margin-top":"10px"},
        disabled: !_unref(redrawData).title,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleRedrawInput()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.redraw.btnText`)), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_unref(Modal), {
      visible: confirmContinue.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((confirmContinue).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      onOk: addList,
      "ok-text": _ctx.$t(`editor.redraw.confirmBtnTxt`),
      onOnCancel: _cache[3] || (_cache[3] = ($event: any) => (confirmContinue.value=false)),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)(`editor.redraw.reConfirm`)), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text"]),
    _createVNode(_unref(Modal), {
      visible: reDrawNoPricing.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((reDrawNoPricing).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      onOk: handleGetTokens,
      "ok-text": _unref(t)(`editor.editorHeader.index.getTokens`),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)(`editor.editorHeader.index.noPricingToOpt`)), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text"])
  ]))
}
}

})